module.exports = {
      id: "angle-up-usage",
      viewBox: "0 0 320 512",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#angle-up",
      toString: function () {
        return this.url;
      }
    }